import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=2447e47c&"
import script from "./SubCategory.vue?vue&type=script&lang=js&"
export * from "./SubCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=2447e47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports